import { SIGNIN_BODY_REQUEST } from 'models';
import { AppAPIInstance } from 'services';

export const loginApi = async (body: SIGNIN_BODY_REQUEST) => {
  return await AppAPIInstance.post('/admin/signin', body);
};
